
import { Component, Mixins } from 'vue-property-decorator';
import SettingsList from '@/features/settings/components/notifications/SettingsList.vue';
import Settings from '@/features/settings/components/notifications/Settings.vue';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { getUserNotificationsPrefs } from '@/features/settings/services/notifications.services';

@Component({
  components: {
    SettingsList,
    Settings,
  },
})
export default class Notifications extends Mixins(ResponsivenessMixin) {
  mounted(): void {
    this.fetchAndCommitUserNotifications();
  }

  private async fetchAndCommitUserNotifications() {
    const notificationPrefs = await getUserNotificationsPrefs();
    this.$store.commit('setNotificationPrefs', notificationPrefs);
  }
}
